export default function (customer) {
  this.name = customer.name;
}
